import { useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { GridGroup } from '../../../models';

export function NewGridGroupPage(props: {
  gridGroups?: GridGroup[];
  scheme?: any[];
  level?: string[];
  gridGroup?: GridGroup;
  onSaved: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [parentOptions, setParentOptions] = useState<any[]>();
  const [hexCodeBackground, setHexCodeBackground] = useState(props.gridGroup?.hexCodeBackground);
  const [hexCodeTitle, setHexCodeTitle] = useState(props.gridGroup?.hexCodeTitle);

  const initialFormValues = {
    name: props.gridGroup?.name || undefined,
    description: props.gridGroup?.description || undefined,
    hexCodeBackground: props.gridGroup?.hexCodeBackground || undefined,
    hexCodeTitle: props.gridGroup?.hexCodeTitle || undefined,
    level: props.level?.join('###'),
  };

  useEffect(() => {
    if (!props.scheme?.length || !props.gridGroups?.length) {
      setParentOptions(undefined);
      return;
    }

    const addGroup = (schemeItem: any, valuePrefix: string, labelPrefix: string, options: any[]) => {
      const group = props.gridGroups?.find(g => g.id === schemeItem.id);
      if (!group) {
        return;
      }
      const value = (valuePrefix + (valuePrefix ? '###' : '') + group.id).trim();
      const label = (labelPrefix + (labelPrefix ? ' > ' : '') + group.name).trim();
      const option: any = { value, label };
      options.push(option);

      if (schemeItem.children?.length) {
        for (const item of schemeItem.children) {
          if (item.itemType === 'fieldGroup') {
            addGroup(item, value, label, newOptions);
          }
        }
      }
    };

    const newOptions: any[] = [];
    for (const item of props.scheme) {
      if (item.itemType === 'fieldGroup') {
        addGroup(item, '', '', newOptions);
      }
    }

    setParentOptions(newOptions);
  }, [props.gridGroups, props.scheme]);

  const onHexCodeBackgroundChange = (e: any) => {
    const value = e.target?.value;
    setHexCodeBackground(value);
  };

  const onHexCodeTitleChange = (e: any) => {
    const value = e.target?.value;
    setHexCodeTitle(value);
  };

  const onFinish = (values: any) => {
    setLoading(true);

    let action;
    const body = {
      ...values,
    };

    if (body.level) {
      body.level = body.level.split('###');
    }

    if (props.gridGroup) {
      action = apiClient.put(`grid-groups/${props.gridGroup?.id}`, body);
    } else {
      action = apiClient.post('grid-groups', body);
    }

    action
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Form labelCol={{ span: 7 }} wrapperCol={{ span: 17 }} initialValues={initialFormValues} onFinish={onFinish}>
        <Form.Item
          label="İsim"
          name="name"
          rules={[
            { required: true, message: 'Zorunlu alan' },
            { max: 100, message: 'En fazla 100 karakter' },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Açıklama"
          name="description"
          rules={[
            { required: true, message: 'Zorunlu alan' },
            { max: 400, message: 'En fazla 400 karakter' },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Arka plan (HEX)" name="hexCodeBackground" rules={[{ max: 9, message: 'En fazla 9 karakter' }]}>
          <div style={{ display: 'flex' }}>
            <Input onChange={onHexCodeBackgroundChange} />
            <div
              style={{
                width: '100px',
                height: '32px',
                marginLeft: '1rem',
                border: '1px solid #dedede',
                backgroundColor: hexCodeBackground,
              }}
            />
          </div>
        </Form.Item>

        <Form.Item label="Başlık (HEX)" name="hexCodeTitle" rules={[{ max: 9, message: 'En fazla 9 karakter' }]}>
          <div style={{ display: 'flex' }}>
            <Input onChange={onHexCodeTitleChange} />
            <div
              style={{
                width: '100px',
                height: '32px',
                marginLeft: '1rem',
                border: '1px solid #dedede',
                backgroundColor: hexCodeTitle,
              }}
            />
          </div>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {props.gridGroup ? 'Kaydet' : 'Ekle'}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
